import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Hint, InlineCode } from '@nejcm/docz-theme-extended';
import submenuPic from '../../public/assets/submenu.jpg';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "menu"
    }}>{`Menu`}</h1>
    <p>{`Improved and redesigned menu:`}</p>
    <ul>
      <li parentName="ul">{`Menu search`}</li>
      <li parentName="ul">{`Right side headings menu with scroll detection`}</li>
      <li parentName="ul">{`Menu groups`}</li>
      <li parentName="ul">{`Sub menus`}</li>
      <li parentName="ul">{`Menu display names`}</li>
    </ul>
    <h2 {...{
      "id": "config"
    }}>{`Config`}</h2>
    <h3 {...{
      "id": "search"
    }}>{`Search`}</h3>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.menu.search`}</inlineCode>{` option to enable or disable search.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    menu: {
      search: true,
    },
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`search`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify if the menu search should be shown.`}</td>
        </tr>
      </tbody>
    </table>
    <hr />
    <h3 {...{
      "id": "headings"
    }}>{`Headings`}</h3>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.menu.headings`}</inlineCode>{` option.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    menu: {
      headings: {
        rightSide: true,
        scrollspy: true,
        depth: 3,
      },
    },
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options-1"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rightSide`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify if the headings menu on the right should be shown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`scrollspy`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify if the headings menu should have scrollspy enabled.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`depth`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`3`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify the depth of headings to be shown. (1 - 6)`}</td>
        </tr>
      </tbody>
    </table>
    <hr />
    <h3 {...{
      "id": "groups"
    }}>{`Groups`}</h3>
    <p>{`Menu items can now be grouped into labeled sections. Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`groups`}</inlineCode>{` option.
The option receives an object where the key is the section name and the value is an array of menu items.
The order of items is reflected in the menu.`}</p>
    <Hint type="info" mdxType="Hint">An empty key ('') represents ungrouped values.</Hint>
    <Hint type="warning" mdxType="Hint">
  Only top level menu items or menu groups can be grouped into sections.
    </Hint>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  groups: {
    '': [],
    API: ['Components', 'UI'],
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options-2"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`groups`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify menu groups where object key is the group name and the value is an array of documents / pages`}</td>
        </tr>
      </tbody>
    </table>
    <hr />
    <h3 {...{
      "id": "sub-menus"
    }}>{`Sub menus`}</h3>
    <p>{`Menu items can now have one level of submenus.
Inside each document there is a `}<inlineCode parentName="p">{`submenu`}</inlineCode>{` option.`}</p>
    <img src={submenuPic} alt="Submenus" />
    <pre><code parentName="pre" {...{
        "className": "language-mdx"
      }}>{`---
name: Footer
route: /ui/footer
menu: UI
submenu: Bottom
tags: ui, footer, footer config, theme, user interface, submenu, sub menu
---

# My mdx file
`}</code></pre>
    <h4 {...{
      "id": "options-3"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`submenu`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of submenu`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "sorting"
    }}>{`Sorting`}</h4>
    <Hint type="warning" mdxType="Hint">
  Sub menus do not have any custom sorting option. For this the docz{' '}
  <InlineCode mdxType="InlineCode">menu</InlineCode> option inside <InlineCode mdxType="InlineCode">doczrc.js</InlineCode>{' '}
  file can be used. Check example bellow.
    </Hint>
    <p>{`Menu:`}</p>
    <pre><code parentName="pre" {...{}}>{`Item 1
Item 2
Item 3
  > Item 3.1
  > Item 3.2
Item 4
Item 5
  > Item 5.1
  > Sub-menu 5.2
    > Item 5.2.1
    > Item 5.2.2
    > Item 5.2.3
  > Item 5.3
  > Sub-menu 5.4
    > Item 5.4.1
  > Item 5.5
Item 6
`}</code></pre>
    <p>{`Code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  menu: [
    'Item 1',
    'Item 2',
    { name: 'Item 3', menu: ['Item 3.1', 'Item 3.2'] },
    'Item 4',
    {
      name: 'Item 5',
      menu: [
        'Item 5.1',
        'Item 5.2.1', // 1st item from Sub-menu 5.2
        'Item 5.2.2', // 2nd item from Sub-menu 5.2
        'Item 5.2.3', // 3rd item from Sub-menu 5.2
        'Item 5.3',
        'Item 5.4.1', // 1st item from Sub-menu 5.4
        'Item 5.5',
      ],
    },
    'Item 6',
  ],
};
`}</code></pre>
    <hr />
    <h3 {...{
      "id": "menu-display-name"
    }}>{`Menu display name`}</h3>
    <p>{`To allow having menus with the same name a `}<inlineCode parentName="p">{`menuDisplayName`}</inlineCode>{` option can be set inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file.
The option receives an object where the key represents the document `}<inlineCode parentName="p">{`name`}</inlineCode>{` and the value is a string to be displayed in the menu.`}</p>
    <Hint type="warning" mdxType="Hint">
  This also applies to <InlineCode mdxType="InlineCode">menu</InlineCode> names.
    </Hint>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  menuDisplayName: {
    UI: 'User Interface',
    Main: 'Main Container',
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options-4"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`menuDisplayName`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify menu display name where object key is the document name and the value is the display name`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      